<div class="input-wrapper">
  <mat-checkbox [checked]="textIsEditable" (change)="textIsEditable = !textIsEditable"> Text editable </mat-checkbox>

  <form #form="ngForm">
    <mad-quick-list-compact
      addLabel="Add Item"
      [allItems]="items"
      [addPossible]="form.valid"
      [readonly]="!textIsEditable"
      [maxItems]="5"
      [minItems]="1"
      (added)="onItemAdded($event)"
      (removed)="onItemRemoved($event)"
    >
      <label>Enter some names</label>
      <ng-template let-item>
        <!-- Custom content below -->
        <span class="fx fx-row">
          <mad-readonly-form-field-wrapper [value]="item.firstName" [readonly]="!textIsEditable">
            <mat-form-field class="form-group">
              <mat-label>First Name</mat-label>
              <input [(ngModel)]="item.firstName" [name]="'firstName-' + item.id" autocomplete="off" class="form-control" matInput />
            </mat-form-field>
          </mad-readonly-form-field-wrapper>

          <mad-readonly-form-field-wrapper [value]="item.lastName" [readonly]="!textIsEditable">
            <mat-form-field class="form-group">
              <mat-label>Last Name</mat-label>
              <input [(ngModel)]="item.lastName" [name]="'lastName-' + item.id" autocomplete="off" class="form-control" matInput required />
              <mat-error> Please enter a last name </mat-error>
            </mat-form-field>
          </mad-readonly-form-field-wrapper>
        </span>
      </ng-template>
    </mad-quick-list-compact>
  </form>
</div>
